import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_MISSION';

export async function createMission(
    userToken: string,
    newMission: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/missions/`,
            data: newMission,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la création de l\'affaire',
            error: error
        });
    }
}
